import React from "react";
import logo from "./logo.svg";
import "./App.css";
import { CONFIG } from "./config";

function App() {
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    fetch(CONFIG.API)
      .then((res) => res.json())
      .then((data) => setData(data.message));
  }, []);

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>{!data ? "Loading..." : data}</p>
	  	<p>hi</p>
	  	<p>{CONFIG.API}</p>
      </header>
    </div>
  );
}

export default App;
